import pineapple from '../assets/images/images/pineapple.png'
import strawberry from '../assets/images/images/strawberry.png'
import banana from '../assets/images/images/banana.png'
import orange from '../assets/images/images/orange.png'
import watermelon from '../assets/images/images/watermelon.png'

const imageList = [
  {
    title: 'Fruit',
    lang: 'en-US',
    words: [
      {
        image: pineapple,
        word: 'pineapple',
        pronounce: 'pineapple',
        translate: 'สัปปะรด'
      },
      {
        image: strawberry,
        word: 'strawberry',
        pronounce: 'strawberry',
        translate: 'สตอเบอร์รี่'
      },
      {
        image: banana,
        word: 'banana',
        pronounce: 'banana',
        translate: 'กล้วย'
      },
      {
        image: orange,
        word: 'orange',
        pronounce: 'orange',
        translate: 'ส้ม'
      },
      {
        image: watermelon,
        word: 'watermelon',
        pronounce: 'watermelon',
        translate: 'แตงโม'
      }
    ]
  }
]

export {
  imageList
}